"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventEmitter = require("wolfy87-eventemitter");
const LogManager_1 = require("../Log/LogManager");
const DomainCommandHandler_1 = require("../Engine/Command/DomainCommandHandler");
const IEventHub_1 = require("../Engine/Event/IEventHub");
const IChatRepository_1 = require("./IChatRepository");
const DomainEventHandler_1 = require("../Engine/Event/DomainEventHandler");
const ChatEvent_1 = require("./ChatEvent");
const ChatCommand_1 = require("./ChatCommand");
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
const SequentialTaskExecutor_1 = require("../Common/SequentialTaskExecutor");
const Chat_1 = require("./Chat");
const ChatDto_1 = require("./Protocol/ChatDto");
const ChatUser_1 = require("./Protocol/ChatUser");
const ChatMessageDto_1 = require("./Protocol/ChatMessageDto");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const immutable_1 = require("immutable");
const ChatMessage_1 = require("./ChatMessage");
const ChatMessageAttachmentStatus_1 = require("./ChatMessageAttachmentStatus");
class ChatClientApplicationService {
    constructor(l, chatFac, chatRepo, cmas, cmdHub, evtHub) {
        this._logger = LogManager_1.logManager.GetLogger("ChatClientApplicationService");
        this._localUser = ChatUser_1.ChatUser.Nobody;
        this.errorOccurred = new EventEmitter();
        this._chatFactory = chatFac;
        this._chatRepo = chatRepo;
        this._chatMessageAttachmentService = cmas;
        this._cmdHub = cmdHub;
        this._evtHub = evtHub;
        this._taskExecutor = new SequentialTaskExecutor_1.SequentialTaskExecutor(this._logger);
        this._commandHandler = new DomainCommandHandler_1.DomainCommandHandler(ChatCommand_1.ChatCommand.Category, this._logger, cmdHub);
        this._commandHandler.registerAsyncCommandHandler(ChatCommand_1.ChatCommand.RequestChat, async (cmd) => this.onRequestChatCommand(cmd));
        this._commandHandler.registerAsyncCommandHandler(ChatCommand_1.ChatCommand.FetchInitialChats, async (cmd) => this.onFetchInitChatsCommand(cmd));
        this._commandHandler.registerAsyncCommandHandler(ChatCommand_1.ChatCommand.QueryNewChatMessages, async (cmd) => this.onFetchNewChatMessagesCommand(cmd));
        this._eventHandler = new DomainEventHandler_1.DomainEventHandler(ChatEvent_1.ChatEvent.Category, this._logger);
        this._eventHandler.registerAsyncEventHandler(ChatEvent_1.ChatEvent.ParticipantSpoke, async (evt) => this.onParticipantSpoke(evt));
        this._eventHandler.registerAsyncEventHandler(ChatEvent_1.ChatEvent.NewChatIsCreated, async (evt) => this.onNewChatIsCreatedEvent(evt));
    }
    get localUser() { return this._localUser; }
    async initAsync(userId, username) {
        if (!userId || !username)
            throw new ChatApplicationServiceError(`Invalid userId=${userId} or username=${username}`);
        this._localUser = new ChatUser_1.ChatUser(userId, username);
        await this._chatMessageAttachmentService.InitAsync();
        await this._chatRepo.InitAsync();
        await this._taskExecutor.initAsync(this.reportError);
        this._cmdHub.errorOccurred.addListener(ChatCommand_1.ChatCommand.Category, (error) => this.reportError(error));
        this._evtHub.errorOccurred.addListener(ChatEvent_1.ChatEvent.Category, (error) => this.reportError(error));
        this._cmdHub.registerCommandHandler(ChatCommand_1.ChatCommand.Category, this);
        this._evtHub.registerEventHandler(ChatEvent_1.ChatEvent.Category, this);
        await this.fetchInitChats();
    }
    async terminateAsync() {
        this._evtHub.unRegisterEventHandler(ChatEvent_1.ChatEvent.Category);
        this._cmdHub.unRegisterCommandHandler(ChatCommand_1.ChatCommand.Category);
        this._evtHub.errorOccurred.removeListener(ChatEvent_1.ChatEvent.Category, this.reportError);
        this._cmdHub.errorOccurred.removeListener(ChatCommand_1.ChatCommand.Category, this.reportError);
        this._taskExecutor.terminateAsync();
        //await this.clearAllLocalData();
        await this._chatRepo.ClearAsync();
        await this._chatMessageAttachmentService.TerminateAsync();
        this.errorOccurred.removeAllListeners();
        this._localUser = ChatUser_1.ChatUser.Nobody;
    }
    handleCommand(cmd) {
        this._commandHandler.handleCommand(cmd);
    }
    async handleCommandAsync(cmd) {
        this._taskExecutor.pushTask(async () => {
            if (!TypeScriptUtils_1.isNullOrEmpty(cmd.targetId)) {
                const chatId = cmd.targetId;
                const chat = await this.retrieveExistChatAsync(chatId);
                if (chat !== Chat_1.Chat.INVALID_CHAT) {
                    await chat.handleCommandAsync(cmd);
                    return;
                }
            }
            await this._commandHandler.handleCommandAsync(cmd);
        }, cmd.name);
    }
    handleEvent(e) {
        if (e.isLocal)
            return;
        this._eventHandler.handleEvent(e);
    }
    async handleEventAsync(evt) {
        if (evt.isLocal)
            return;
        this._taskExecutor.pushTask(async () => {
            if (!TypeScriptUtils_1.isNullOrEmpty(evt.entityId)) {
                const chatId = evt.entityId;
                const chat = await this.retrieveExistChatAsync(chatId);
                if (chat !== Chat_1.Chat.INVALID_CHAT) {
                    await chat.handleEventAsync(evt);
                    return;
                }
            }
            await this._eventHandler.handleEventAsync(evt);
        }, evt.name);
    }
    subscribeEventHandler(eventName, onEventHandler) {
        return this._evtHub.subscribeEventHandler(ChatEvent_1.ChatEvent.Category, eventName, onEventHandler, (err) => this.reportError(err));
    }
    subscribeEventAsyncHandler(eventName, onEventHandler) {
        return this._evtHub.subscribeEventAsyncHandler(ChatEvent_1.ChatEvent.Category, eventName, onEventHandler, (err) => this.reportError(err));
    }
    async onParticipantSpoke(evt) {
        const chatIdCmDtos = evt.bodyTo();
        const chatId = chatIdCmDtos.Item1;
        const chatTempId = chatIdCmDtos.Item2;
        const cmDtos = chatIdCmDtos.Item3.map(cmDtoObj => new ChatMessageDto_1.ChatMessageDto(cmDtoObj));
        this._logger.debug(`Chat.Id=${chatId}不在，用Chat.TempId=${chatTempId}查Chat`);
        const fromTmpIdChat = await this.retrieveExistChatAsync(chatTempId);
        if (fromTmpIdChat !== Chat_1.Chat.INVALID_CHAT) {
            this._logger.debug(`用Chat.TempId查到Chat=${fromTmpIdChat.id}, 開始處理${ChatEvent_1.ChatEvent.ParticipantSpoke}`);
            await fromTmpIdChat.handleEventAsync(evt);
            return;
        }
        this._logger.debug(`用Chat.Id, Chat.TempId都查不到Chat，新增一個Chat`);
        const createdChat = this._chatFactory.NewChatFromEncodedId(chatTempId, chatId);
        if (createdChat === Chat_1.Chat.INVALID_CHAT) {
            this._logger.error(`無法根據${ChatEvent_1.ChatEvent.ParticipantSpoke}來找出/建立Chat`);
            return;
        }
        this._logger.debug(`根據${ChatEvent_1.ChatEvent.ParticipantSpoke}在本地建立新的Chat: Id=${createdChat.id}, TempId=${createdChat.TempId}`);
        const localCreatedChatDto = createdChat.ToChatDto();
        await this._evtHub.publishAsync(ChatEvent_1.ChatEvent.NewChatIsCreatedEvent(localCreatedChatDto), [IEventHub_1.EventReceiver.CLIENT]);
        await createdChat.handleEventAsync(evt);
    }
    async chatOfIdAsync(id) {
        const result = await this.executeAsync(async () => {
            const chat = await this.retrieveExistChatAsync(id);
            return chat.ToChatDto();
        }, ChatDto_1.ChatDto.INVALID_CHAT);
        return result;
    }
    async chatOfIdWithMessagesAsync(chatId, messageCount) {
        const result = await this.executeAsync(async () => {
            const existChat = await this.retrieveExistChatAsync(chatId);
            if (existChat === Chat_1.Chat.INVALID_CHAT)
                return ChatDto_1.ChatDto.INVALID_CHAT;
            const chat = await this._chatRepo.LoadWithSpecifiedChatMessageCountAsync(existChat.id, messageCount);
            return chat.ToChatDto();
        }, ChatDto_1.ChatDto.INVALID_CHAT);
        return result;
    }
    async openChatWithAsync(para) {
        return this.addExecuteItemAsync(async () => {
            return this.internalOpenChatWithAsync(para);
        }, this.openChatWithAsync.name, "");
    }
    async internalOpenChatWithAsync(para) {
        let usernames = immutable_1.List();
        if (typeof para === "string") {
            if (!para)
                throw new ChatApplicationServiceError(`Invalid username=${para}`);
            usernames = usernames.push(para);
        }
        else {
            const paraStringAy = para;
            for (const u of paraStringAy) {
                if (!u)
                    throw new ChatApplicationServiceError(`Invalid usernames=${paraStringAy.join(",")}`);
            }
            usernames = usernames.concat(para).toList();
        }
        if (usernames.size === 0)
            throw new ChatApplicationServiceError("No usernames");
        const _curChatUser = this.localUser;
        const participants = immutable_1.OrderedSet(usernames.push(_curChatUser.name));
        this._logger.debug(`使用者進入與${participants.join(", ")}的Chat`);
        const chatTempId = Chat_1.Chat.MakeTemp1on1ChatId(participants);
        const existChat = await this._chatRepo.FindChatByTempIdAsync(chatTempId);
        if (existChat !== Chat_1.Chat.INVALID_CHAT) {
            this._logger.debug(`與${participants.join(", ")}的Chat存在，直接回Id，Chat.Id=${existChat.id}`);
            return existChat.id;
        }
        const newChat = this._chatFactory.NewChatFromParticipants(participants.toArray());
        this._logger.debug(`與${participants.join(", ")}的Chat不存在，建立一個Chat.Id=${newChat.id}，存入ChatRepository`);
        await this._chatRepo.SaveAsync(newChat);
        return newChat.id;
    }
    async openOrCreateChatWithAsync(usernames) {
        return this.addExecuteItemAsync(async () => {
            for (const u of usernames) {
                if (!u)
                    throw new ChatApplicationServiceError(`Invalid usernames=${usernames.join(",")}`);
            }
            const chatId = await this.internalOpenChatWithAsync(usernames);
            if (!Chat_1.Chat.IsTempChatId(chatId)) {
                // 不是Temp的Chat.Id直接回傳
                return chatId;
            }
            const needToCreateChat = await this.retrieveExistChatAsync(chatId);
            // 請求Server產生新Chat
            const chatDto = needToCreateChat.ToChatDto();
            await this._cmdHub.sendCommandAsync(ChatCommand_1.ChatCommand.RequestChatCommand(chatDto));
            //等3000ms看新的Chat有沒有回來，中間每過500ms就會檢查一次，可以有比較快的回應速度
            await TypeScriptUtils_1.AsyncUtil.AsyncWaitUntilOverload1(async () => {
                const waitingChat = await this.retrieveExistChatAsync(needToCreateChat.id);
                return !Chat_1.Chat.IsTempChatId(waitingChat.id);
            }, 3000, 500, "OpenOrCreateChatWithAsync");
            const serviceConfirmedChat = await this.retrieveExistChatAsync(needToCreateChat.id);
            if (Chat_1.Chat.IsTempChatId(serviceConfirmedChat.id))
                throw new ChatApplicationServiceError("Cannot get formal Chat.");
            return serviceConfirmedChat.id;
        }, this.openOrCreateChatWithAsync.name, "");
    }
    async onRequestChatCommand(rtcCmd) {
        switch (rtcCmd.type) {
            case RtcCommand_1.CmdType.ResponseAccept:
                // 已從Service端已成功拿回有正式Id的Chat，替換掉本地端的TempChat，通知UI層
                const chatDto = new ChatDto_1.ChatDto(rtcCmd.contentTo());
                await this.logChat(chatDto);
                break;
        }
    }
    async onNewChatIsCreatedEvent(evt) {
        //收到有NewChat產生
        const chatDto = new ChatDto_1.ChatDto(evt.bodyTo());
        await this.logChat(chatDto);
    }
    async getCurrentAllChatsAsync(messageCount) {
        const chatDtos = await this.executeAsync(async () => {
            const _curChatUser = this.localUser;
            const activeChats = await this._chatRepo.ActiveChatsOfUserAsync(_curChatUser.name, messageCount);
            return activeChats.map(c => c.ToChatDto());
        }, []);
        return chatDtos;
    }
    /// <summary>
    /// 清除本地端Chat，用來作測試，Production不會用到
    /// </summary>
    async clearChatAsync(chatId) {
        return this.addExecuteItemAsync(async () => {
            const chat = await this.retrieveExistChatAsync(chatId);
            if (chat === Chat_1.Chat.INVALID_CHAT) {
                this._logger.error(`沒Chat=${chatId}, 無法刪除`);
                return;
            }
            this._logger.debug(`移除chat=${chat.id}`);
            await this._chatRepo.DeleteAsync(chat.id);
        }, this.clearChatAsync.name);
    }
    async speakToChatAsync(cmDto) {
        return this.addExecuteItemAsync(async () => {
            const _curChatUser = this.localUser;
            if (cmDto.speaker !== _curChatUser.name)
                throw new ChatApplicationServiceError(`Speaker=${cmDto.speaker} should be LocalUser=${_curChatUser.name}`);
            const belongToChatId = cmDto.belongToChatId;
            const chat = await this.retrieveExistChatAsync(belongToChatId);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`Cannot chat to ${cmDto.belongToChatId}, because chat doesn't exist.`);
            const cm = chat.NewChatMessageFrom(cmDto);
            await chat.ParticipantSpeakAsync(cm);
        }, this.speakToChatAsync.name);
    }
    async speakCmsToChatAsync(cmsDtos) {
        return this.addExecuteItemAsync(async () => {
            const cms = immutable_1.List(cmsDtos.map(cmDto => chat.NewChatMessageFrom(cmDto)));
            if (cms.size === 0)
                throw new ChatApplicationServiceError("No ChatMessage");
            const firstCm = cms.first();
            const belongToChatId = firstCm.BelongToChatId;
            const chat = await this.retrieveExistChatAsync(belongToChatId);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`Cannot chat to ${firstCm.BelongToChatId}, because chat doesn't exist.`);
            await cms.forEach(async (cm) => {
                if (!cm)
                    return;
                await chat.ParticipantSpeakAsync(cm);
            });
        }, this.speakCmsToChatAsync.name);
    }
    async startNewChatAsync(name, tags, participants, chatMessageDtos) {
        return this.addExecuteItemAsync(async () => {
            const _curChatUser = this.localUser;
            const chat = this._chatFactory.NewChatFromMostProperties(Chat_1.Chat.NO_SPECIFIED_ID, name, _curChatUser.name, tags, participants);
            const chatMessages = chatMessageDtos.map(cmDto => chat.NewChatMessageFrom(cmDto));
            await chatMessages.forEach(async (cm) => {
                await chat.ParticipantSpeakAsync(cm);
            });
            return chat.id;
        }, this.startNewChatAsync.name, "");
    }
    async newTextChatMessageAsync(belongToChatId, speakerUserName, text, dt) {
        return await this.executeAsync(async () => {
            const chat = await this.retrieveExistChatAsync(belongToChatId);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`Invalid Chat.Id=${belongToChatId}`);
            const cm = chat.NewTextChatMessage(speakerUserName, text, dt);
            return cm.ToChatMessageDto();
        }, ChatMessageDto_1.ChatMessageDto.INVALID_CHAT_MESSAGE);
    }
    async newImageChatMessageAsync(belongToChatId, speakUserName, uploadFileExt, contentType, thumbnailBlob, attachmentBlob) {
        return await this.executeAsync(async () => {
            const chat = await this.retrieveExistChatAsync(belongToChatId);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`Invalid Chat.Id=${belongToChatId}`);
            const cm = chat.NewImageChatMessage({
                speakUserName: speakUserName,
                uploadFileExt: uploadFileExt,
                contentType: contentType,
                thumbnailChecker: async () => thumbnailBlob.size > 0,
                thumbnailSupplier: async () => thumbnailBlob,
                attachmentChecker: async () => attachmentBlob.size > 0,
                attachmentSupplier: async () => attachmentBlob,
            });
            return cm.ToChatMessageDto();
        }, ChatMessageDto_1.ChatMessageDto.INVALID_CHAT_MESSAGE);
    }
    async newAudioChatMessageAsync(belongToChatId, speakUserName, uploadFileExt, contentType, attachmentSupplier) {
        return await this.executeAsync(async () => {
            const chat = await this.retrieveExistChatAsync(belongToChatId);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`Invalid Chat.Id=${belongToChatId}`);
            const cm = chat.NewAudioChatMessage({
                speakUserName: speakUserName,
                uploadFileExt: uploadFileExt,
                contentType: contentType,
                attachmentChecker: async () => attachmentSupplier.size > 0,
                attachmentSupplier: async () => attachmentSupplier,
            });
            return cm.ToChatMessageDto();
        }, ChatMessageDto_1.ChatMessageDto.INVALID_CHAT_MESSAGE);
    }
    async doesChatMessageBelongToChatAsync(cmDto, chatId) {
        return await this.executeAsync(async () => {
            const chat = await this.retrieveExistChatAsync(cmDto.belongToChatId);
            return chat.id === chatId;
        }, false);
    }
    async chatHasEarlierChatMessageBeforeAsync(chatId, refCmDto) {
        return await this.executeAsync(async () => {
            const chat = await this.retrieveExistChatAsync(chatId);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`Invalid Chat.Id=${chatId}`);
            const cm = refCmDto ? chat.NewChatMessageFrom(refCmDto) : ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
            const loadedCm = cm !== ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE ? await chat.ChatMessageOfIdAsync(cm.id) : ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
            return chat.HasEarlierChatMessageBefore(loadedCm);
        }, false);
    }
    async retrieveChatMessagesOfChatBeforeAsync(chatId, count, refCmDto) {
        const result = await this.executeAsync(async () => {
            if (!chatId)
                throw new ChatApplicationServiceError(`arg chatId should not be empty.`);
            if (count < 0 && count !== IChatRepository_1.ChatRepositoryConstant.LOAD_NO_LIMIT)
                throw new ChatApplicationServiceError(`Invalid count=${count}`);
            const chat = await this.retrieveExistChatAsync(chatId);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`Invalid Chat.Id=${chatId}`);
            const refCm = await this.makeRefChatMessage(chatId, refCmDto);
            const earlierCms = await chat.ChatMessagesBeforeAsync(refCm, count);
            return earlierCms.map(cm => cm.ToChatMessageDto());
        }, []);
        return result;
    }
    async chatMessageOfChatLaterAsync(chatId, refCmDto, count) {
        const result = await this.executeAsync(async () => {
            if (!chatId)
                throw new ChatApplicationServiceError(`arg chatId should not be empty.`);
            if (count < 0 && count !== IChatRepository_1.ChatRepositoryConstant.LOAD_NO_LIMIT)
                throw new ChatApplicationServiceError(`Invalid count=${count}`);
            const chat = await this.retrieveExistChatAsync(chatId);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`Invalid Chat.Id=${chatId}`);
            const refCm = await this.makeRefChatMessage(chatId, refCmDto);
            const laterCms = await chat.ChatMessagesAfterAsync(refCm, count);
            return laterCms.map(cm => cm.ToChatMessageDto());
        }, []);
        return result;
    }
    async makeRefChatMessage(localChatId, localRefCmDto) {
        if (!localRefCmDto || localRefCmDto === ChatMessageDto_1.ChatMessageDto.INVALID_CHAT_MESSAGE) {
            return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
        }
        else {
            const refCm = await this.retrieveChatMessageOfChatAsync(localChatId, localRefCmDto.id);
            return refCm;
        }
    }
    async retrieveChatMessageOfChatAsync(chatId, cmId) {
        const chat = await this.retrieveExistChatAsync(chatId);
        if (chat === Chat_1.Chat.INVALID_CHAT)
            return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
        const cm = await chat.ChatMessageOfIdAsync(cmId);
        return cm;
    }
    async reportReadMessageCountToLatest(chatId, participants = []) {
        return this.addExecuteItemAsync(async () => {
            const chat = await this.retrieveExistChatAsync(chatId, participants);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`No chat=${chatId} can be report.`);
            const _curChatUser = this.localUser;
            await chat.UpdateParticipantReadCount(_curChatUser.name, -1);
        }, this.reportReadMessageCountToLatest.name);
    }
    async queryUnreadMessageCount(chatId, participants = []) {
        const result = await this.executeAsync(async () => {
            const _curChatUser = this.localUser;
            const chat = await this.retrieveExistChatAsync(chatId, participants);
            if (chat === Chat_1.Chat.INVALID_CHAT)
                throw new ChatApplicationServiceError(`chat=${chatId} not exist.`);
            return chat.UnreadMessageCount(_curChatUser.name);
        }, 0);
        return result;
    }
    async retrieveChatMessageThumbnailStatusAsync(cm) {
        const result = await this.executeAsync(async () => {
            const thumbnailName = cm.ThumbnailName();
            return await this._chatMessageAttachmentService.QueryAttachmentStatusAsync(thumbnailName);
        }, ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus.INVALID);
        return result;
    }
    async retrieveChatMessageAttachmentStatusAsync(cm) {
        const result = await this.executeAsync(async () => {
            const attachmentName = cm.AttachmentName();
            return await this._chatMessageAttachmentService.QueryAttachmentStatusAsync(attachmentName);
        }, ChatMessageAttachmentStatus_1.ChatMessageAttachmentStatus.INVALID);
        return result;
    }
    async requestDownloadChatMessageAttachmentAsync(cmDto, onErrorAct) {
        const result = await this.executeAsync(async () => {
            const cm = await this._chatRepo.LoadChatMessageAsync(cmDto.belongToChatId, cmDto.id);
            if (cm === ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE)
                throw new ChatApplicationServiceError(`ChatMessage=${cmDto} doesn't exist.`);
            const queryResult = await this._chatMessageAttachmentService.QueryRemoteAttachmentStatus(cm, cm.AttachmentName());
            switch (queryResult) {
                case ChatMessageAttachmentStatus_1.Status.PrepareReceive:
                case ChatMessageAttachmentStatus_1.Status.Receiving:
                case ChatMessageAttachmentStatus_1.Status.Received:
                    //以上三種狀態表示Service端還在收，可以讓ChatAttachmentService進行下載
                    await this._chatMessageAttachmentService.DownloadAttachment(cm, (error) => {
                        if (onErrorAct)
                            onErrorAct(cmDto, error);
                    });
                    return true;
                default:
                    //無法下載的狀況，Client端無法自行處理，只好把可知的狀態吐出來
                    throw new ChatApplicationServiceError(`Unable to handle attachement, queryResult=${queryResult}`);
            }
        }, false);
        return result;
    }
    async retrieveChatMessageAttachmentFilePathNameAsync(cmDto) {
        const result = await this.executeAsync(async () => {
            const cm = await this._chatRepo.LoadChatMessageAsync(cmDto.belongToChatId, cmDto.id);
            if (cm === ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE)
                throw new ChatApplicationServiceError(`ChatMessage=${cmDto} doesn't exist.`);
            return this._chatMessageAttachmentService.QueryAttachmentFilePathName(cm);
        }, "");
        return result;
    }
    async retrieveChatMessageAttachmentBytesAsync(cmDto) {
        const result = await this.executeAsync(async () => {
            const cm = await this._chatRepo.LoadChatMessageAsync(cmDto.belongToChatId, cmDto.id);
            if (cm === ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE)
                throw new ChatApplicationServiceError(`ChatMessage=${cmDto} doesn't exist.`);
            return await this._chatMessageAttachmentService.RetrieveAttachmentBytesAsync(cm.AttachmentName());
        }, new Blob());
        return result;
    }
    async logChat(incomingChatDto) {
        if (this.localUser === ChatUser_1.ChatUser.Nobody)
            throw new ChatApplicationServiceError("No current user.");
        //用正規Chat.Id找
        let existsChat = await this.retrieveExistChatAsync(incomingChatDto.id);
        if (existsChat === Chat_1.Chat.INVALID_CHAT) {
            //正規Id找不到用TempId找
            existsChat = await this.retrieveExistChatAsync(incomingChatDto.tempId);
        }
        if (existsChat === Chat_1.Chat.INVALID_CHAT) {
            this._logger.debug(`用Id=${incomingChatDto.id}&TepmChatId=${incomingChatDto.tempId}都找不到，不存在的Chat，新增一個`);
            const createdChat = this._chatFactory.NewChatFromChatDto(incomingChatDto);
            await createdChat.DownloadAttachmentsAsync(); //整個Chat下來沒機會下載Attachment，在這邊下載
            await this._chatRepo.SaveAsync(createdChat);
            //本地端有新的Chat，往UI層通知
            const localCreatedChat = await this._chatRepo.LoadWithSpecifiedChatMessageCountAsync(createdChat.id, 1); //帶著最新的ChatMessage送上去
            const localCreatedChatDto = localCreatedChat.ToChatDto();
            await this._evtHub.publishAsync(ChatEvent_1.ChatEvent.NewChatIsCreatedEvent(localCreatedChatDto), [IEventHub_1.EventReceiver.CLIENT]);
        }
        else {
            if (Chat_1.Chat.IsTempChatId(existsChat.id)) {
                this._logger.debug(`移除使用暫存Id的Chat=${existsChat.id}換成正規Id=${incomingChatDto.id}`);
                existsChat = await this._chatRepo.LoadWithSpecifiedChatMessageCountAsync(existsChat.id, IChatRepository_1.ChatRepositoryConstant.LOAD_NO_LIMIT);
                const incomingChat = this._chatFactory.NewChatFromChatDto(incomingChatDto);
                await this._chatRepo.DeleteAsync(existsChat.id);
                await this._chatRepo.SaveAsync(incomingChat);
                const loadedChat = await this._chatRepo.LoadWithSpecifiedChatMessageCountAsync(incomingChat.id, IChatRepository_1.ChatRepositoryConstant.LOAD_NO_LIMIT);
                await loadedChat.DownloadAttachmentsAsync();
                await loadedChat.CompleteReplaceChatAsync(existsChat);
            }
            else {
                this._logger.debug(`已經存在的Chat，準備附加 ${incomingChatDto.messages.length} ChatMessage`);
                const incomingCms = incomingChatDto.messages.map(cmDto => existsChat.NewChatMessageFrom(cmDto));
                await existsChat.AppendChatMessageAsync(incomingCms, incomingChatDto.totalChatMessageCount);
            }
        }
        this._logger.debug(`更新Chat=${incomingChatDto.id}完成`);
    }
    async retrieveExistChatAsync(chatId, participants = []) {
        const _curChatUser = this.localUser;
        if (TypeScriptUtils_1.isNullOrEmpty(chatId)) {
            // 沒有chatId沒有participants可參考,沒得找
            if (participants.length === 0)
                return Chat_1.Chat.INVALID_CHAT;
            //不是Chat.TEMP_ID_PREFIX開頭，表示是從Web.Client送過來，沒帶任何Id
            this._logger.debug(`chatId為=${chatId}但無法找到, 作一對一TempId來找`);
            const participantSet = immutable_1.OrderedSet(participants).add(_curChatUser.name);
            const tempChatId = Chat_1.Chat.MakeTemp1on1ChatId(participantSet);
            return await this._chatRepo.FindChatByTempIdAsync(tempChatId);
        }
        else {
            const retrivingChat = await this._chatRepo.ChatOfIdAsync(chatId);
            // 直接在Repository找到就回傳
            if (retrivingChat !== Chat_1.Chat.INVALID_CHAT)
                return retrivingChat;
            // 看送進來的Id是否符合TempId的格式
            if (!Chat_1.Chat.IsTempChatId(chatId))
                return Chat_1.Chat.INVALID_CHAT;
            this._logger.debug(`輸入的Id=${chatId}有${Chat_1.Chat.TEMP_ID_PREFIX}，找TempId`);
            return await this._chatRepo.FindChatByTempIdAsync(chatId);
        }
    }
    async fetchInitChats() {
        const _curChatUser = this.localUser;
        if (_curChatUser === ChatUser_1.ChatUser.Nobody)
            throw new ChatApplicationServiceError("No current user.");
        const allChat = await this._chatRepo.ActiveChatsOfUserAsync(_curChatUser.name);
        const allChatIdAndLastCm = allChat.map(chat => {
            const lastCm = chat.LastChatMessage();
            return new TypeScriptUtils_1.Tuple2({
                Item1: chat.id,
                Item2: lastCm.ToChatMessageDto()
            });
        });
        const fetchInitChatsCmd = ChatCommand_1.ChatCommand.FetchInitialChatsCommand(allChatIdAndLastCm);
        await this._cmdHub.sendCommandAsync(fetchInitChatsCmd);
    }
    async onFetchInitChatsCommand(cmd) {
        if (cmd.type === RtcCommand_1.CmdType.ResponseAccept) {
            const initChats = cmd.contentTo();
            const processedInitChats = initChats
                .map(c => new ChatDto_1.ChatDto(c));
            for (const c of processedInitChats) {
                await this.logChat(c);
            }
        }
    }
    async fetchNewChatMessagesAsync() {
        const _curChatUser = this.localUser;
        if (_curChatUser === ChatUser_1.ChatUser.Nobody)
            throw new ChatApplicationServiceError("No current user.");
        const allChat = await this._chatRepo.ActiveChatsOfUserAsync(_curChatUser.name);
        const allChatIdTotalMsgCount = allChat.map(chat => new TypeScriptUtils_1.Tuple2({
            Item1: chat.id,
            Item2: chat.TotalChatMessageCount,
        }));
        const cmd = ChatCommand_1.ChatCommand.QueryNewChatMessagesCommand(allChatIdTotalMsgCount);
        await this._cmdHub.sendCommandAsync(cmd);
    }
    async onFetchNewChatMessagesCommand(cmd) {
        if (cmd.type === RtcCommand_1.CmdType.ResponseAccept) {
            const allChatIdCmsTotalMsgCount = cmd.contentTo();
            for (const chatIdAndCm of allChatIdCmsTotalMsgCount) {
                const chatId = chatIdAndCm.Item1;
                const cmDtos = chatIdAndCm.Item2;
                const totalMsgCount = chatIdAndCm.Item3;
                const chat = await this.retrieveExistChatAsync(chatId);
                if (chat === Chat_1.Chat.INVALID_CHAT) {
                    this._logger.error(`無法根據ChatMessage=${chatId}建立Chat，忽略傳下來的Chat=${chatId}`);
                    return;
                }
                this._logger.debug(`已經存在的Chat，準備附加 ${cmDtos.length} ChatMessage`);
                const incomingCms = cmDtos.map(cmDto => chat.NewChatMessageFrom(cmDto));
                await chat.AppendChatMessageAsync(incomingCms, totalMsgCount);
            }
        }
    }
    async generateRandomChatMessage(chatId, speaker, count = 100) {
        for (let i = 0; i < count; i++) {
            this._logger.debug(`Generating ${i} message`);
            const text = `${i}.${new Date()}`;
            const cmDto = await this.newTextChatMessageAsync(chatId, speaker, text);
            await this.speakToChatAsync(cmDto);
            await TypeScriptUtils_1.delay(30);
        }
    }
    async generateRepeatedLastChatMessage(chatId, count = 10) {
        const chatDto = await this.chatOfIdWithMessagesAsync(chatId, 1);
        const lastCmDto = chatDto.lastChatMessage();
        if (lastCmDto === ChatMessageDto_1.ChatMessageDto.INVALID_CHAT_MESSAGE)
            return; //沒有最後一個訊息可用
        for (let i = 0; i < count; i++) {
            this._logger.debug(`Generating ${i} message`);
            const newCmDto = await GenerateNewCmDtoFromCmDto(lastCmDto);
            if (newCmDto === ChatMessageDto_1.ChatMessageDto.INVALID_CHAT_MESSAGE)
                return;
            await this.speakToChatAsync(newCmDto);
            await TypeScriptUtils_1.delay(100);
        }
        const chatAppService = this;
        async function GenerateNewCmDtoFromCmDto(orgCmDto) {
            if (orgCmDto.IsText()) {
                return await chatAppService.newTextChatMessageAsync(chatDto.id, lastCmDto.speaker, orgCmDto.text);
            }
            else if (orgCmDto.IsImage()) {
                return await chatAppService.newImageChatMessageAsync(chatDto.id, lastCmDto.speaker, "xxx", lastCmDto.contentType, await orgCmDto.GetThumbnailAsync(), await orgCmDto.GetAttachmentAsync());
            }
            else if (orgCmDto.IsAudio()) {
                return await chatAppService.newAudioChatMessageAsync(chatDto.id, lastCmDto.speaker, "xxx", lastCmDto.contentType, await orgCmDto.GetAttachmentAsync());
            }
            else
                return ChatMessageDto_1.ChatMessageDto.INVALID_CHAT_MESSAGE;
        }
    }
    // public async clearAllLocalData(): Promise<void> {
    //   await this.executeAsync(async () => {
    //     await this._chatMessageAttachmentService.ClearAsync();
    //     await this._chatRepo.ClearAsync();
    //   });
    // }
    async executeAsync(operation, defaultReturnValue = {}, memberName = "") {
        try {
            const localUser = this.localUser;
            if (localUser === ChatUser_1.ChatUser.Nobody)
                throw new ChatApplicationServiceError("local user should be valid user");
            return await operation();
        }
        catch (err) {
            const errorMsg = `${memberName || ""}: ${err.message}`;
            const appServiceError = new ChatApplicationServiceError(errorMsg, err);
            this.reportError(appServiceError);
            return defaultReturnValue;
        }
    }
    execute(operation, defaultReturnValue = {}, memberName = "") {
        try {
            const localUser = this.localUser;
            if (localUser === ChatUser_1.ChatUser.Nobody)
                throw new ChatApplicationServiceError("local user should be valid user");
            return operation();
        }
        catch (err) {
            const errorMsg = `${memberName || ""}: ${err.message}`;
            const appServiceError = new ChatApplicationServiceError(errorMsg, err);
            this.reportError(appServiceError);
            return defaultReturnValue;
        }
    }
    addExecuteItemAsync(operation, memberName = "", defaultReturnValue = {}) {
        if (this.localUser === ChatUser_1.ChatUser.Nobody)
            throw new ChatApplicationServiceError("local user should be valid user");
        return this._taskExecutor.pushTask(operation, memberName, defaultReturnValue);
    }
    reportError(error, memberName = "") {
        try {
            const memberNamePrefix = memberName ? `${memberName}: ` : "";
            const errorMsg = `${memberNamePrefix}${error.message}`;
            const chatAppServiceError = (error instanceof ChatApplicationServiceError) ? error : new ChatApplicationServiceError(errorMsg, error);
            this.errorOccurred.emitEvent(exports.ChatApplicationServiceErrorName, [chatAppServiceError]);
        }
        catch (e) {
            // Prevent outside error handler throwing error again.
            this._logger.error(e.message, e);
        }
    }
}
exports.ChatClientApplicationService = ChatClientApplicationService;
exports.ChatApplicationServiceErrorName = "ChatApplicationServiceError";
class ChatApplicationServiceError extends CommonBaseError_1.CommonBaseError {
}
exports.ChatApplicationServiceError = ChatApplicationServiceError;
//# sourceMappingURL=ChatClientApplicationService.js.map